import * as React from 'react';
import { LinkOutlined } from '@ant-design/icons';
import { endpoints } from '../../../config';
import { HomeShortcut } from '../types';

type Props = {
    shortcut: HomeShortcut;
};

const getShortcutImageUrl = (shortcut: HomeShortcut): string =>
    `${endpoints.iotaUrl}home-screen-cards/image?path=${encodeURIComponent(shortcut.imagePath!)}`;

const HomeCustomCard: React.FC<Props> = ({ shortcut }) => {
    return (
        <div
            className="polaroid-card"
            onClick={() => window.open(shortcut.url, '_blank', 'noopener,noreferrer')}
        >
            <div className="polaroid-image">
                {shortcut.imagePath ? (
                    <img src={getShortcutImageUrl(shortcut)} />
                ) : (
                    <div className="polaroid-image-placeholder">
                        <span>{shortcut.title}</span>
                    </div>
                )}
            </div>
            <div className="polaroid-caption">
                <h4 className="polaroid-title">{shortcut.title}</h4>
                {shortcut.description && (
                    <p className="polaroid-description">{shortcut.description}</p>
                )}
                <span className="polaroid-link">
                    Open <LinkOutlined />
                </span>
            </div>
        </div>
    );
};

export default HomeCustomCard;
